import { ApiClient } from "@/services/apiClient";
import { roundSportsCardPrice } from "@/services/collectibles/collectiblesHelpers";
import type { Collectible, CollectibleId } from "@/services/collectibles/collectiblesTypes";
import { CategoryId } from "@/services/collection/categories";

/** @deprecated Still used in magazine widgets. Use Elastic Collectible instead. */
export const fetchCollectibleById = async (id: CollectibleId): Promise<Collectible> => {
  const url = "api-public/collectible/" + id;
  return ApiClient.getPublic<Collectible>(url).then(({ data }) => {
    // Sports cards: round the current price to a clean tier and clear historical prices (not relevant for this category).
    if (data.categoryId === CategoryId.SportsCards) {
      if (data.price !== null) {
        data.price = { ...data.price, price: roundSportsCardPrice(data.price.price) };
      }
      data.prices = [];
    }
    return data;
  });
};
